export class Usuario {
  id?: number;
  nome?: string;
  email?: string;
  ativo?: boolean;
  parceiroId?: number;
  coligadaId?: number;
}
